import { FileStatusResponse, ProjektDokument } from "domain/Types";
import React from "react";
import { UI_FILE_STRINGS } from "types/constants";

type DocumentsSummaryProps = {
  documents: ProjektDokument[];
  fileChecks: FileStatusResponse[];
};

type FileSummaryProps = {
  checkState: string;
  fileName: string;
  hasVirus?: boolean;
};

export const DocumentsSummary: React.FC<DocumentsSummaryProps> = ({ documents, fileChecks }) => {
  return (
    <>
      {documents.map((x, index) => {
        const foundFileCheck = fileChecks.find((c) => c.fileId === x.fileId);
        return (
          <FileSummary
            key={`fileSummary_${index}`}
            fileName={x.fileName}
            checkState={foundFileCheck?.status ?? UI_FILE_STRINGS.UNCHECKED_STATE}
            hasVirus={!foundFileCheck?.isVirusFree}
          />
        );
      })}
    </>
  );
};

const FileSummary: React.FC<FileSummaryProps> = ({ fileName, checkState, hasVirus = false }) => {
  const uiCheckState =
    checkState === UI_FILE_STRINGS.UNCHECKED_STATE
      ? UI_FILE_STRINGS.CHECKING
      : !hasVirus
        ? UI_FILE_STRINGS.VIRUS_FREE
        : UI_FILE_STRINGS.THREAT_FOUND;
  const textColor = checkState === UI_FILE_STRINGS.UNCHECKED_STATE ? "text-warning" : hasVirus ? "text-danger" : "";
  return (
    <div className={textColor}>
      {fileName} ({uiCheckState})
    </div>
  );
};

export default FileSummary;
